<template>
  <!-- <MapModal
    :modalNode="modalNode"
    :title="ModelNase.title"
    :id="ModelNase.id"
    :close="shutDown"
  >
    <template slot="content">
      <div class="content">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入方案名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="模拟类型" prop="radio">
            <el-radio-group v-model="ruleForm.radio">
              <el-radio label="1">全局模拟</el-radio>
              <el-radio label="2">工点模拟</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="文件" prop="file">
            <span class="uploadStyle">
              <el-input
                v-model="ruleForm.file"
                :readonly="true"
                placeholder="还未选择文件"
              ></el-input>

              <el-upload
                action=""
                res="upload"
                :http-request="httpRequest"
                :before-upload="beforeUpload"
                multiple
                :show-file-list="false"
              >
                <el-button
                  type="primary"
                  style="margin-left:12px;
                  height: 36px;
                  background-color: rgba(34, 162, 195, 0.8);border-color: rgba(34, 162, 195, 0.9)"
                  >选择压缩包</el-button
                >
              </el-upload>


              <el-button
                type="primary"
                @click="DownloadTemplate"
                style="margin-left:10px;
                margin-top:2px;
                height: 36px;
                  background-color: rgba(34, 162, 195, 0.8);border-color: rgba(34, 162, 195, 0.9)"
                >下载数据模板包</el-button
              >
            </span>
          </el-form-item>
          <el-form-item class="submitBtn btns">
            <el-button
              @click="shutDown"
              style="
              width: 92px;
                height: 34px;
                margin-right: 10px;"
              >取消</el-button
            >
            <el-button
              type="primary"
              style="width: 116px;
                height: 34px;
                background-color: rgba(34, 162, 195, 0.8);
                margin-right: 9px;"
              @click="onSubmit('form')"
              >开始解析</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </template>
  </MapModal> -->

  <div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px">
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="ruleForm.name"
          placeholder="请输入方案名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="模拟类型" prop="radio">
        <el-radio-group v-model="ruleForm.radio">
          <el-radio label="global">全局模拟</el-radio>
          <el-radio label="working">工点模拟</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="文件" prop="file">
        <span class="uploadStyle">
          <el-input
            v-model="ruleForm.file"
            :readonly="true"
            placeholder="还未选择文件"
          ></el-input>

          <el-upload
            action=""
            res="upload"
            :http-request="httpRequest"
            :before-upload="beforeUpload"
            multiple
            :show-file-list="false"
          >
            <el-button
              style="margin-left:12px;
                  height: 36px;"
              >选择压缩包</el-button
            >
          </el-upload>

          <el-button
            @click="DownloadTemplate"
            style="margin-left:10px;
                margin-top:2px;
                height: 36px;
                  "
            >下载数据模板包</el-button
          >
        </span>
      </el-form-item>
      <!-- <el-form-item class="submitBtn btns">
        <el-button
          @click="shutDown"
          style="
              width: 92px;
                height: 34px;
                margin-right: 10px;"
          >取消</el-button
        >
        <el-button
          type="primary"
          style="width: 116px;
                height: 34px;
                background-color: rgba(34, 162, 195, 0.8);
                margin-right: 9px;"
          @click="onSubmit('form')"
          >开始解析</el-button
        >
      </el-form-item> -->
    </el-form>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm('sceneForm')"
        >确 定</el-button
      >
    </div> -->
  </div>
</template>

<script>
const MapModal = () => import("@/components/common/mapModal/Index");
import {
  parseConstruct,
  scence,
  bimSimConstructGetProcessId,
  bimSimConstructGetProgress,
} from "@/api/api";
import axios from "axios";

export default {
  components: {
    MapModal,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      console.log(value, "value");
      if (value === "") {
        callback(new Error("请选择压缩包"));
      } else {
        // if (this.ruleForm.file !== "") {
        //   this.$refs.ruleForm.validateField("file");
        // }
        callback();
      }
    };
    return {
      importDataPageShow: false,
      ModelNase: {
        title: "导入数据",
        id: "importDataPage",
      },
      modalNode: {
        ModelNase: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            x: 12,
            y: -66,
            // left: 22,
            // top:20
            unit: "%", // 默认px
          },
          width: "596px",
          // auto 自适应
          height: "300px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      ruleForm: {
        name: "",
        radio: "global",
        file: "",
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        file: [{ required: true, validator: validatePass, trigger: "change" }],
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      formData: null,
      analysisSuccess: "start",
    };
  },
  methods: {
    // 点击上传
    httpRequest(item) {
      this.ruleForm.file = item.file.name;
      // debugger
      console.log(item);
      // this.modalNode.ModelNase.loading = true;
      item.file.remarks = "";

      let formData = new FormData();

      formData.append("ProjectId", this.projectId); //项目ID
      formData.append("Type", this.ruleForm.radio);
      formData.append("SchemeName", this.ruleForm.name);
      // formData.append("SceneId", this.$parent.sceneId); //场景ID
      formData.append("UploadFile", item.file);
      this.formData = formData;

      this.$notify({
        title: "上传成功",
        message: "",
        type: "success",
        duration: 1000,
        offset: 320,
      });
    },
    // 上传之前对文件作限制
    beforeUpload(file) {},
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$parent.$parent.progressData = 0;
          this.$parent.$parent.statusType = "";
          this.analysisSuccess = "start";
          this.$parent.$parent.onSubmitLoading = true;
          if (this.ruleForm.radio == "global") {
            bimSimConstructGetProcessId().then((res) => {
              var url = "/baseIP/BimSimConstruct/ParseConstruct";
              this.formData.append("progressId", res.data.data);
              this.analysisFun(url, this.formData);
              //轮询
              this.pollingFun(res.data.data);
            });
          } else {
            this.startAnalysis();
            var url = "/baseIP/BimSimWorking/add";
            this.analysisFun(url, this.formData, true);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    analysisFun(url, formData, type) {
      axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$notify({
              title: "解析成功",
              message: "",
              type: "success",
              duration: 1000,
              offset: 320,
            });

            this.analysisSuccess = "success";
            if (type) this.successAnalysis();
          } else {
            this.$notify({
              title: "失败",
              message: res.data.message,
              type: "error",
              duration: 2000,
              offset: 320,
            });
            this.analysisSuccess = "error";
            this.$parent.$parent.onSubmitLoading = false;
            this.errorAnalysis();
          }
        })
        .catch((error) => {
          this.$parent.$parent.onSubmitLoading = false;
          this.analysisSuccess = "error";
          this.errorAnalysis();
          console.log(error);
          this.$notify({
            title: "失败",
            message: error.message,
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
    },
    pollingFun(id) {
      let timer = setInterval(() => {
        bimSimConstructGetProgress({ processId: id }).then((res) => {
          if (res.data)
            this.$parent.$parent.progressData = res.data.data
              ? res.data.data
              : 0;
          if (res.data && res.data.data == 100) {
            this.$parent.$parent.statusType = "success";
            this.$parent.$parent.onSubmitLoading = false;
            setTimeout(() => {
              this.$emit("refresh");
              this.$emit("shutDown");
            }, 1500);
          }
        });
      }, 1000);

      // 离开当前页面时销毁定时器
      this.$once("hook:beforeDestroy", () => {
        clearInterval(timer);
        timer = null;
      });
    },
    startAnalysis() {
      setTimeout(() => {
        if (this.analysisSuccess == "start") {
          this.$parent.$parent.progressData = 10;
          setTimeout(() => {
            if (this.analysisSuccess == "start") {
              this.$parent.$parent.progressData = 15;
              setTimeout(() => {
                if (this.analysisSuccess == "start") {
                  this.$parent.$parent.progressData = 22;
                  setTimeout(() => {
                    if (this.analysisSuccess == "start") {
                      this.$parent.$parent.progressData = 28;
                      setTimeout(() => {
                        if (this.analysisSuccess == "start") {
                          this.$parent.$parent.progressData = 36;
                          setTimeout(() => {
                            if (this.analysisSuccess == "start") {
                              this.$parent.$parent.progressData = 44;
                              setTimeout(() => {
                                if (this.analysisSuccess == "start") {
                                  this.$parent.$parent.progressData = 48;
                                  setTimeout(() => {
                                    if (this.analysisSuccess == "start") {
                                      this.$parent.$parent.progressData = 55;
                                      setTimeout(() => {
                                        if (this.analysisSuccess == "start") {
                                          this.$parent.$parent.progressData = 67;
                                          setTimeout(() => {
                                            if (
                                              this.analysisSuccess == "start"
                                            ) {
                                              this.$parent.$parent.progressData = 74;
                                              setTimeout(() => {
                                                if (
                                                  this.analysisSuccess ==
                                                  "start"
                                                ) {
                                                  this.$parent.$parent.progressData = 82;
                                                  setTimeout(() => {
                                                    if (
                                                      this.analysisSuccess ==
                                                      "start"
                                                    ) {
                                                      this.$parent.$parent.progressData = 87;
                                                    }
                                                  }, 2000);
                                                }
                                              }, 2000);
                                            }
                                          }, 2000);
                                        }
                                      }, 2000);
                                    }
                                  }, 2000);
                                }
                              }, 2000);
                            }
                          }, 2000);
                        }
                      }, 2000);
                    }
                  }, 2000);
                }
              }, 1000);
            }
          }, 1000);
        }
      }, 500);
    },
    successAnalysis() {
      this.$parent.$parent.progressData = 92;
      setTimeout(() => {
        this.$parent.$parent.progressData = 100;
        this.$parent.$parent.statusType = "success";
        this.$parent.$parent.onSubmitLoading = false;
        setTimeout(() => {
          this.$emit("refresh");
          this.$emit("shutDown");
        }, 1500);
      }, 800);
    },
    errorAnalysis() {
      this.$parent.$parent.statusType = "exception";
    },
    shutDown() {
      console.log("老方法 触发关闭");

      this.$emit("shutDown");
    },
    DownloadTemplate() {
      axios({
        method: "get",
        url: "/baseIP/Upload/Sim/Sim-SampleData.zip", // 请求地址
        responseType: "blob", // 设置接收格式为blob格式
        params: {},
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + window.sessionStorage.getItem("token"),
          "X-Authorization":
            "Bearer " + window.sessionStorage.getItem("refreshToken"),
        },
      }).then((res) => {
        this.downloadFile(res);
      });
    },
    downloadFile(res) {
      let blob = new Blob([res.data], {
        type: "application/octet-stream;charset=UTF-8",
      });
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = "none";
      downloadElement.href = href;
      downloadElement.download = decodeURI("数据模板.zip"); //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放通过调用URL.createObjectURL()创建的URL对象。
    },
  },
  created() {
    this.$parent.$parent.onSubmitLoading = false;
    this.$parent.$parent.progressData = 0;
    this.$parent.$parent.statusType = "";
    this.analysisSuccess = "start";
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 15px 15px 0 15px;
}
/deep/.el-form.settings
  .el-form-item
  .el-form-item__content
  .el-input[data-v-2e44ca1c] {
  width: 250px !important;
}
/deep/.el-input {
  width: 250px;
}
.submitBtn {
  display: flex;
  flex-direction: inherit !important;
}
.btns {
  margin-bottom: 12px;
  .el-form-item__content {
    width: 166px;
    @include button_primary();
    @include button_default();
  }
}
.uploadStyle {
  display: flex;
}
/deep/.el-button {
  padding: 12px 15px;
  font-size: 12px;
}
/deep/.el-form-item__label {
  color: #606266 !important;
}

/deep/.el-radio__label {
  color: #606266 !important;
}
/deep/.el-radio.is-checked .el-radio__label {
  color: #606266 !important;
}
/deep/.el-radio .el-radio__input.is-checked + .el-radio__label {
  color: #409eff !important;
}
/deep/.el-radio__input.is-checked .el-radio__inner:after {
  transform: translate(-50%, -50%) scale(1);
}
/deep/.el-radio__inner:after {
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background-color: #fff;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.15s ease-in;
}
</style>
